/**
 * Converia Backend
 */


/**
 * Document ready stuff
 */
$(document).ready(function () {

    /**
     * Menu Accordion
     */

    $('ul.drawers').accordion({
        active: $('.open.drawer').index(),
        header: 'a.drawer-handle',
        selectedClass: 'open',
        event: 'click',
        autoheight: true,
        heightStyle: 'content',
        navigation: true,
        navigationFilter: function () {
            if ($(this).parent().hasClass('active')) {
                return true;
            } else {
                return false;
            }
        }
    });


    /**
     * Drawer height calc
     */

    function resetHeight() {
        drawerWrapper = $('.drawers-wrapper').outerHeight();

        $('.app-main-sidebar .app-nav-sub').css({
            'min-height': drawerWrapper
        });
    }

    resetHeight();

    $('.drawer-handle').on('click', function () {
        setTimeout(function () {
            resetHeight();
        }, 100);
    });


    /**
     * Dashboard functionality
     */

    $('div.status-stage span.status-time b').each(function (e) {
        var $this = $(this);
        var ttDate = $this.parent().next('time').text();

        $this.attr('title', ttDate);
    });


    /**
     * Global Tooltip Handling
     */

    $('[data-toggle="tooltip"]').tooltip({
        delay: {
            show: 100,
            hide: 200
        }
    });


    /**
     * Chosen
     * lang defitions
     */

    var chosenLang = $('html').attr('lang');
    var resultTextLang = '';
    var frameSwitch = $('.form-frame-switch');

    if (chosenLang == 'de') {
        resultTextLang = 'Keine Ergebnisse für';
    }

    if (chosenLang == 'en') {
        resultTextLang = 'No results for';
    }


    /**
     * Chosen page-header frame switch
     */

    $('*[data-navbar-frame-chosen="1"]')
        .chosen({
            disable_search_threshold: 0, // always show search input
            no_results_text: resultTextLang,
            width: '450px',
            search_contains: true
        })
        .on('keypress', function (e) {
            // auto submit on keypress (enter key)
            if (e.which == 13) {
                $(frameSwitch).submit();
            }
        })
        .change(function () {

            // auto submit on conference change
            $(frameSwitch).submit();
        });


    /**
     * Chosen page-header frame switch
     */

    $('.aside-tools').find('select[name="SRfrmId"]')
        .chosen({
            disable_search_threshold: 0, // always show search input
            no_results_text: resultTextLang,
            width: '180px'
        });


    /**
     * Chosen page content module type
     */

    $('.content-module-type')
        .chosen({
            disable_search_threshold: 0, // always show search input
            no_results_text: resultTextLang,
            width: '250px'
        })
        .on('keypress', function (e) {
            var contentModuleType = $(this).closest('.form-module-type');

            // auto submit on keypress (enter key)
            if (e.which == 13) {
                contentModuleType.submit();
            }
        })
        .change(function () {
            var contentModuleType = $(this).closest('.form-module-type');
            // auto submit
            contentModuleType.submit();
        });


    /**
     * Chosen page content module content
     */

    $('.content-module-content')
        .chosen({
            disable_search_threshold: 0, // always show search input
            no_results_text: resultTextLang,
            width: '250px'
        })
        .on('keypress', function (e) {
            var contentModuleContent = $(this).closest('.form-module-content');
            // auto submit on keypress (enter key)
            if (e.which == 13) {
                contentModuleContent.submit();
            }
        })
        .change(function () {
            var contentModuleContent = $(this).closest('.form-module-content');
            // auto submit
            contentModuleContent.submit();
        });

}); // document ready end


/**
 * Init Vanilla JS Stuff
 */

document.addEventListener('DOMContentLoaded', function () {

});
